import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../utils/api";
import { getSession, setSession } from "../utils/auth";

export default function ChangePasswordPage() {
  const navigate = useNavigate();
  const session = getSession();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (newPassword !== confirmPassword) {
      setError("New passwords do not match.");
      return;
    }
    if (newPassword.length < 8) {
      setError("New password must be at least 8 characters.");
      return;
    }

    setLoading(true);
    try {
      await changePassword(currentPassword, newPassword);
      // Clear the mustChangePassword flag in session
      if (session) {
        setSession({ ...session, mustChangePassword: false });
      }
      navigate("/dashboard", { replace: true });
    } catch (err) {
      let msg = err.message || "Failed to change password.";
      try {
        const parsed = JSON.parse(msg);
        msg = parsed?.message || msg;
      } catch {
        // not JSON, use as-is
      }
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-login">
      <div className="login-left">
        <div className="login-left-content">
          <img src="/assets/img/logo/continentallogo.jpg" alt="CH BioBank" className="login-brand-logo" />
          <h1 className="login-brand-title">CH BioBank</h1>
          <p className="login-brand-desc">Your account was created by an administrator. Please set a new password before continuing.</p>
          <div className="login-features">
            <div className="login-feature">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              <span>Secure &amp; Encrypted</span>
            </div>
            <div className="login-feature">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
              <span>Password Protected</span>
            </div>
          </div>
        </div>
      </div>
      <div className="login-right">
        <div className="login-card">
          <h2 className="login-title">Set New Password</h2>
          <p className="login-subtitle">
            Welcome, <strong>{session?.displayName || session?.username}</strong>. Please change your temporary password to continue.
          </p>
          <form onSubmit={handleSubmit} autoComplete="off" noValidate>
            <div className="form-group">
              <label>Current (Temporary) Password</label>
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="input-lg"
                required
                placeholder="Enter your current password"
              />
            </div>
            <div className="form-group">
              <label>New Password</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="input-lg"
                required
                placeholder="Enter new password"
              />
            </div>
            <div className="form-group">
              <label>Confirm New Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="input-lg"
                required
                placeholder="Confirm new password"
              />
            </div>
            <div className="login-actions">
              <button className="btn-primary-action login-btn" type="submit" disabled={loading}>
                {loading ? "Changing…" : "Change Password"}
              </button>
            </div>
            {error && <div className="form-alert alert-error">{error}</div>}
          </form>
        </div>
      </div>
    </div>
  );
}
